export const formatSortConfig = {
  video: [
    'mp4',
    'webm',
    'avi',
    'mov',
    'mkv',
    'flv',
    'wmv',
  ],
  audio: [
    'mp3',
    'opus',
    'm4a',
    'aac',
    'ogg',
    'wav',
    'flac',
  ],
};
